import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function KeyCell({ rowData: { key } }: CellProps) {
  const { searchString } = useSearchContext();
  return <HighlightText text={key} searchText={searchString} />;
}
